import React, { useState, useRef, useContext, useEffect } from 'react';
import { Form, FloatingLabel } from 'react-bootstrap';
import { userToken, executeLaravelAPI, showToastMessage, userSrd, createGa4Event,getCustomCookie } from '../../Admin/Utils';
import { SearchVisibilityContext } from '../Layouts/SearchVisibilityContext';
import { CompletePurchase } from '../../Admin/GoogleAnalytics';


const FormEnquiry = ({ projectId, developerId, projectName }) => {
    const formRef = useRef(null);
    const [errorMsg, setErrors] = useState({});

    const { setPriceFormSubmitted } = useContext(SearchVisibilityContext);
    const initialFormState = {
        enquiry_name: '',
        // enquiry_email: '',
        enquiry_phone: '',
        // enquiry_message: '',
        project_id: '',
        developer_id: '',
        agreetnc: false
    };
    const [formData, setFormData] = useState(initialFormState);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    useEffect(() => {
        // Reset formSubmitted when projectId changes
        setPriceFormSubmitted(false);
    }, [projectId, setPriceFormSubmitted]); // Trigger when projectId changes


    const getUTMParameter = (param) => {
        const params = new URLSearchParams(window.location.search);
        return params.get(param);
    };
    
    const getCookie = (name) => {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
    };
    
    const loadGTM = () => {
        return new Promise((resolve) => {
            if (typeof window.gtag !== "function") {
                const script = document.createElement("script");
                script.async = true;
                script.src = "https://www.googletagmanager.com/gtag/js?id=AW-16665468291";
                script.onload = () => {
                    window.dataLayer = window.dataLayer || [];
                    window.gtag = function () {
                        window.dataLayer.push(arguments);
                    };
                    window.gtag("js", new Date());
                    window.gtag("config", "AW-16665468291");
                    console.log("✅ GTM loaded successfully");
                    resolve();
                };
                document.head.appendChild(script);
            } else {
                resolve();
            }
        });
    };
    
    const loadFacebookPixel = () => {
        return new Promise((resolve) => {
            if (typeof window.fbq !== "function") {
                (function (f, b, e, v, n, t, s) {
                    if (f.fbq) return;
                    n = f.fbq = function () {
                        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                    };
                    if (!f._fbq) f._fbq = n;
                    n.push = n;
                    n.loaded = !0;
                    n.version = "2.0";
                    n.queue = [];
                    t = b.createElement(e);
                    t.async = !0;
                    t.src = v;
                    s = b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t, s);
                })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    
                window.fbq("init", "800472858694618");
                window.fbq("track", "PageView");
                console.log("✅ Facebook Pixel loaded successfully");
                resolve();
            } else {
                resolve();
            }
        });
    };

    const source = getUTMParameter("utm_source") || getCookie("utm_source") || localStorage.getItem("utm_source");
    if(source && source !== null && source !== undefined){
        if (source.toLowerCase() === "google") {
            loadGTM();
        }
        if (source.toLowerCase() === "facebook") {
            loadFacebookPixel();
        }
    }
    // console.log("noparameter");
    const fireLoginAndPixelConversion = async () => {
        // Check for UTM parameters
        const source = getUTMParameter("utm_source") || getCookie("utm_source") || localStorage.getItem("utm_source");
        const campaign = getUTMParameter("utm_campaign") || getCookie("utm_campaign") || localStorage.getItem("utm_campaign");
        const medium = getUTMParameter("utm_medium") || getCookie("utm_medium") || localStorage.getItem("utm_medium");
        const content = getUTMParameter("utm_content") || getCookie("utm_content") || localStorage.getItem("utm_content");
        const term = getUTMParameter("utm_term") || getCookie("utm_term") || localStorage.getItem("utm_term");
    

        if (!source && !campaign && !medium) {
            console.log("❌ No UTM parameters found. Tracking events NOT fired.");
            return;
        }
    
        // Load respective tracking scripts based on UTM source
        if (source.toLowerCase() === "google") {
            //await loadGTM();
            if (typeof window.gtag === "function") {
                window.gtag("event", "conversion", {
                    send_to: "AW-16665468291/ysI3CPSojskZEIO724o-",
                });
                console.log("🔥 GTM Login conversion event fired");
            }
        } else if (source.toLowerCase() === "facebook") {
            //await loadFacebookPixel();
            setTimeout(() => {
                if (typeof window.fbq === "function") {
                    window.fbq("track", "Lead");
                    console.log("🔥 Facebook Pixel Lead event fired on login!");
                }
            }, 500);
        } else {
            console.log("ℹ️ UTM source is neither Google nor Facebook. No tracking scripts loaded.");
        }
    };

    const handleUserAddSubmit = async (e) => {
        //  e.preventDefault();
        try {
            const { enquiry_name, enquiry_phone, agreetnc, enquiry_locality, enquiry_triggered_from } = formData;
            e.target.setAttribute('disabled', 'disabled');
            if (projectId != '' && developerId != '') {
                formData.project_id = projectId;
                formData.developer_id = developerId;
            } else {
                formData.project_id = document.getElementById('enquiry_project_id').value || '';
                formData.developer_id = document.getElementById('enquiry_developer_id').value || '';
            }

            formData.enquiry_locality = document.getElementById('enquiry_locality').value || '';
            formData.enquiry_triggered_from = document.getElementById('enquiry_triggered_from').value || '';

            formData.utm_source = document.getElementById('utm_source').value || '';
            formData.utm_medium = document.getElementById('utm_medium').value || '';
            formData.utm_campaign = document.getElementById('utm_campaign').value || '';
            formData.utm_content = document.getElementById('utm_content').value || '';
            formData.utm_term = document.getElementById('utm_term').value || '';

            const messages = [];

            if (!enquiry_name.trim()) {
                messages.enquiry_name = ['Name is required'];
            } else if (!/^[a-z A-Z\s]+$/.test(enquiry_name)) {
                messages.enquiry_name = ['Name should only contain alphabetic characters'];
            }

            // if (!enquiry_email.trim()) {
            //     messages.enquiry_email = ['Email is required'];
            // } else if (!/^\S+@\S+\.\S+$/.test(enquiry_email)) {
            //     messages.enquiry_email = ['Invalid email address'];
            // }

            if (!enquiry_phone.trim()) {
                messages.enquiry_phone = ['Phone no is required'];
            } else if (enquiry_phone.length < 6) {
                messages.enquiry_phone = ['Phone no must be at least 6 characters long'];
            } else if (!/^[6-9]\d{9}$/.test(enquiry_phone)) {
                messages.enquiry_phone = ['Invalid phone number format'];
            }


            // if (!agreetnc) {
            //     messages.agreetnc = 'You must agree to the terms and conditions';
            // }

            if (Object.keys(messages).length > 0) {
                setErrors(messages);
                return;
            }



            if (userSrd !== null || userSrd !== undefined || userSrd !== '') {
                formData.srd = userSrd;
            }

            await fireLoginAndPixelConversion();
            //console.log("formadata:  " ,formData);return false;
            // return;
            // Assuming userToken is defined elsewhere
            let result = await executeLaravelAPI('add-enquiry', formData, 'POST', userToken);
            // console.table(result.message);
            if (result.status === 409 || result.status === 400) {
                setErrors(result.message);
                e.target.removeAttribute('disabled');
                // console.log(result.message.email);
            } else if (result.status === 200) {
                showToastMessage('Your request has been submitted successfully.', 'top-right', 'success');
                CompletePurchase(formData.enquiry_phone, window.location.pathname)
                createGa4Event('selldo_form_submitted', 'Selldo Form Submitted Detail page', `${formData.enquiry_phone}`);
                setFormData(initialFormState);
                formRef.current.reset();
                document.getElementById('overlayEnquiry').style.display = 'none';
                //setformSubmited(true);
                setPriceFormSubmitted(true);
                e.target.removeAttribute('disabled');
            } else {
                showToastMessage('Failed to submit request', 'top-right', 'error');
                e.target.removeAttribute('disabled');
            }
        } catch (error) {
            console.error('Error:', error);
            showToastMessage('Failed to submit request', 'top-right', 'error');
        }
    }

    return (
        <div className="left-form mt-4 bg-white d-flex flex-column gap-4 realestate-form">
            <div className="d-flex align-items-center gap-2 justify-content-center form-heading">
                {/* <div className="circle">
                <div className="letter fw-bold">R</div>
            </div> */}
                <span className="text-dark fs-4 fw-bold priceTitle">Get a call back from our expert</span>
            </div>

            <><form id="enquiry-form-pdp" className="enquiry-form" ref={formRef}>
                <input type="hidden" id="utm_source" name="utm_source" value={getCustomCookie('utm_source') ?? ''} />
                <input type="hidden" id="utm_medium" name="utm_medium" value={getCustomCookie('utm_medium') ?? ''} />
                <input type="hidden" id="utm_campaign" name="utm_campaign" value={getCustomCookie('utm_campaign') ?? ''} />
                <input type="hidden" id="utm_content" name="utm_content" value={getCustomCookie('utm_content') ?? ''} />
                <input type="hidden" id="utm_term" name="utm_term" value={getCustomCookie('utm_term') ?? ''} />
                
                <div className="d-flex flex-column gap-3">
                    <Form.Group className="row mb-2">
                        <Form.Control type="hidden" name='project_id' id='enquiry_project_id' />
                        <Form.Control type="hidden" name='developer_id' id='enquiry_developer_id' />
                        <Form.Control type="hidden" name='enquiry_locality' id='enquiry_locality' />
                        <Form.Control type="hidden" name='enquiry_triggered_from' id='enquiry_triggered_from' />
                        <div className="col-sm-12 position-relative">
                            <FloatingLabel controlId="floatingName1" label="Name">

                                <Form.Control placeholder="Name" type="text" name='enquiry_name' onChange={handleChange} />
                            </FloatingLabel>
                            {errorMsg && errorMsg.enquiry_name && <div className="text-danger error-msg">{errorMsg.enquiry_name[0]}</div>}
                        </div>
                    </Form.Group>
                    {/* <Form.Group className="row mb-2">
                    <div className="col-sm-12 position-relative">
                        <FloatingLabel controlId="floatingEmail1" label="Email">
                            <Form.Control placeholder="Email" type="text" name='enquiry_email' onChange={handleChange} />
                        </FloatingLabel>
                        {errorMsg && errorMsg.enquiry_email && <div className="text-danger error-msg">{errorMsg.enquiry_email[0]}</div>}
                    </div>
                </Form.Group> */}
                    <Form.Group className="row mb-2">
                        <div className="col-sm-12 position-relative">
                            <FloatingLabel controlId="floatingPhone1" label="Phone Number">
                                <Form.Control placeholder="Phone Number" type="text" name='enquiry_phone' pattern="[0-9]{10}" maxLength="10" minLength="10" onChange={handleChange} />
                            </FloatingLabel>
                            {errorMsg && errorMsg.enquiry_phone && <div className="text-danger error-msg">{errorMsg.enquiry_phone[0]}</div>}
                        </div>
                    </Form.Group>
                    {/* <Form.Group className="row mb-2">
                    <div className="col-sm-12 position-relative">
                        <FloatingLabel controlId="floatingMsg" label="Message">
                            <Form.Control placeholder="Message" type="text" name='enquiry_message' onChange={handleChange} />
                        </FloatingLabel>
                        {errorMsg.message && <div className="text-danger error-msg">{errorMsg.message[0]}</div>}
                    </div>
                </Form.Group> */}
                    <div className="form-check c-pointer position-relative">
                        <input className="form-check-input agreetnc" name="agreetnc" type="checkbox" id="flexCheckChecked" checked={formData.agreetnc} onChange={handleChange} />
                        <label className="form-check-label fs-6" htmlFor="flexCheckChecked">
                            I agree to the <a target='_blank' href="https://corporate.beyondwalls.com/terms-and-conditions" ><span className="text-primary  text-decoration-underline textorange"> terms and
                                conditions</span></a>
                        </label>
                        {errorMsg.agreetnc && <div className="text-danger error-msg lasterror">{errorMsg.agreetnc}</div>}
                    </div>
                    <a onClick={(e) => [handleUserAddSubmit(e), createGa4Event("project_detail_page_enquiry", 'Project Enquiry Form', `${projectName}`)]} id="register" className="btn sc register-btn text-center">
                        <span className="d-block signin text-uppercase">ENQUIRE NOW</span>
                    </a>

                </div>
            </form></>

        </div>
    );
};

export default FormEnquiry;